import { render, staticRenderFns } from "./DetailServiceReshell.vue?vue&type=template&id=d1b9c75e&"
import script from "./DetailServiceReshell.vue?vue&type=script&lang=js&"
export * from "./DetailServiceReshell.vue?vue&type=script&lang=js&"
import style0 from "./DetailServiceReshell.vue?vue&type=style&index=0&id=d1b9c75e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports